import $ from 'jquery';
import  'slick-carousel';

$(document).ready(function () {

  $('[js-home-slider]').slick({
    arrows: false,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    mobileFirst: true,
    draggable: false,
    adaptiveHeight: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false,
    speed: 500,
    fade: true,
    cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    responsive: [ ]
  });

});



// WEBPACK FOOTER //
// ./assets/scripts/pages/home.js